export default {
  shinkansen: {
    title: '日本新干线订票｜Triplabo',
    caption: '日本新干线官方指定平台',
    description:
      '日本新干线官方指定平台，提前预订热门新干线路线，无需排队取票，直接扫二维码即可快速进站乘车。',
    departure: '出发',
    arrival: '到达',
    departureDate: '出发日期',
    ticketType: '新干线车票',
    earliestTime: '最早发车时间',
    latestTime: '最晚发车时间',
    travelTime: '乘车时间',
    attractions: '热门景点',
    stock: {
      sufficient: '有票',
      limited: '余票不足',
      soldOut: '票已售罄'
    },
    book: {
      reserve: '预订',
      selectSeat: '选择座位'
    },
    preference: {
      earliestDeparture: '最早出发',
      fastestArrival: '最快到达',
      lowestPrice: '价格最低'
    },
    popularRoutes: {
      title: '热门路线',
      jr: {
        name: '日本JR官方合作平台',
        description: '直连日本铁道官方订票系统，值得信赖'
      },
      qr: {
        name: '秒出票，扫码进站乘车',
        description: '无需排队取票，直接扫码进站畅通无阻'
      },
      reserve: {
        name: '提前一天预订，退改方便',
        description:
          '行程有变？乘车1日前可取消重订！\n（*自由席当天内均可使用）'
      }
    },
    usageInstructions: {
      title: '使用说明',
      step1: {
        title: '线上预订车票，获取二维码乘车券',
        description: '*根据JR规定，新干线车票目前只能在出发前1个月内出票。'
      },
      step2: {
        title: '前往新干线站台，扫码进站',
        description: '*若遇到错误提示，请出示二维码乘车券给闸机附近的工作人员。'
      },
      step3: {
        title: '寻找站台和列车',
        description: '*自由席请寻找设置了自由席车厢的列车，座位先到先得。'
      }
    },
    duration: {
      hoursAndMinutes: '{{hours}}时{{minutes}}分',
      minutes: '{{minutes}}分',
      approximately: '约{{duration}}'
    },
    tags: {
      shinkansen: '新干线',
      qrcode: '二维码乘车'
    },
    faq: {
      q1: '购买后如何乘坐新干线？',
      a1: '本商品为直接用二维码乘坐新干线的电子票券，无需在车站换票。您支付后系统将在新干线官方后台实时订票，乘车用二维码将展示在小程序订单票券中，并发送到您下单时所填写的邮箱，请行前确认收到的二维码票券信息是否无误。\n购买多张票时会收到多张二维码票券，一人一码，二维码只可扫一次，敬请注意。 当天请提前前往新干线的闸机口扫码进站。在进站后的屏幕上找到票券上的车次所显示的月台，并看好出发时间和车次乘车（新干线站台均在大站，人流量大，请至少提前半小时，预留充足时间进站乘车）。',
      q2: '错过了乘车时间，怎么办？',
      a2: '如果您错过了新干线的乘车时间，您可以直接乘坐当天内的其他列车的自由席而无需退票。若您想确保有座位，可在车站购买新的指定席车票，但之前购买的票无法取消退款。',
      q3: '能携带多大的行李？',
      a3: '您最多可以携带三边合计不超过250cm的行李，否则可能无法携带乘车。\n车厢内行李架：每节车厢上方都有行李架，可以放置尺寸适中的手提行李和背包。\n座位前方空间：您也可以利用座位前方空间放置小型行李（会挤压腿部空间）。\n车厢尾部行李区：部分列车在车厢尾部（最后一节车厢或靠近洗手间处）设有较大的行李存放区，可以放置大件行李，但空间有限，先到先得。\n*不允许把行李箱放在过道上或座位间通道，以免影响其他乘客通行。'
    }
  }
};
